/**
 * The After Referral choices, as the admin portal offers them: Repeat sound
 * only when there is a referral sound to repeat, Hang up always. The list
 * must agree with getReferralType, or the dropdown shows a value it does
 * not offer.
 */
const getReferralOptions = (hasSound: boolean): string[] => {
    const options = [
        'hangup',
        'voicemail',
        'fixed',
        'mobile',
        'both',
        'number',
    ];

    return hasSound ? ['loop', ...options] : options;
};

export default getReferralOptions;
